import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectStore = (state) => state.audio;

const makeSelectAudioPlaying = () => createSelector(
  selectStore,
  ({ playing }) => playing,
);

const makeSelectSrc = () => createSelector(
  selectStore,
  ({ src }) => src,
);

export {
  makeSelectSrc,
  makeSelectAudioPlaying,
};
